import { useQuery } from '@apollo/client';

import { defaultProfessionalFields } from '@xing-com/crate-lebenslauf-constants';
import { GetVitaFieldsDocument } from '@xing-com/crate-lebenslauf-graphql';
import type { VitaFieldsData } from '@xing-com/crate-lebenslauf-graphql';

export const useVitaFields = (): VitaFieldsData => {
  const { data } = useQuery(GetVitaFieldsDocument, {
    ssr: false,
  });

  const industries = data?.industries || defaultProfessionalFields.industries;

  const careerLevels =
    data?.careerLevels || defaultProfessionalFields.careerLevels;

  const disciplines =
    data?.disciplines || defaultProfessionalFields.disciplines;

  return { industries, careerLevels, disciplines };
};
